import { assignIn, map, sortBy } from 'lodash';
import Api from 'services/Api';
import notifications from 'services/Notifications';
import router from 'router';
import { flags } from '../../config';

function reset() {
  return {
    // data
    apps: [],
    boards: {},
    cards: {},

    // state
    appId: null,
    boardId: null,
  };
}
const state = reset();

const actions = {
  /**
   * Loads app and if successful, navigates to the app's home pgae
   */
  showApp({ dispatch }, appId) {
    return dispatch('loadApp', appId).then(() => {
      router.push({ name: 'app', params: { appId } });
      notifications.clear();
    });
  },

  /**
   * Loads and caches an app and its boards
   */
  loadApp({ state, commit }, appId) {
    const { appId: prevAppId } = state;

    // get app data
    const app = state.apps.find(app => app.id === appId);
    // reject if user doesn't own app
    if (!app) {
      return Promise.reject('errors.app_not_found');
    }

    if (prevAppId !== null && prevAppId !== appId) {
      console.log('Clearing previous app id data');
      commit('audience/clearFilters', null, { root: true });
      commit('audience/applyFilters', null, { root: true });
      commit('audience/clearUsers', null, { root: true });
    }

    // resolve if boards already loaded
    if (state.boards[appId]) {
      commit('appId', appId);
      return Promise.resolve();
    }

    // otherwise load app
    console.log('Loading app: ' + app.name, app.id);

    const boards = [
      {
        id: 'audience',
        title: 'Audience',
      },
    ];
    commit('boards', { appId, boards });
    commit('appId', appId);

    return Promise.resolve();
  },

  /**
   * Loads and caches a board and its cards
   */
  loadBoard({ state, commit }, boardId) {
    // resolve if cards already loaded
    if (state.cards[boardId]) {
      commit('boardId', boardId);
      return Promise.resolve();
    }

    // otherwise load board
    console.log('Loading board: ' + boardId);
    Api.insights.get(`boards/${boardId}`).then(res => {
      commit('cards', { boardId, cards: res.body.cards });
      commit('boardId', boardId);
      console.log('OK!');
    });
  },
};

const mutations = {
  reset(state) {
    Object.assign(state, reset());
  },

  apps(state, value) {
    state.apps = value;
  },

  boards(state, { appId, boards }) {
    state.boards[appId] = sortBy(boards, 'position').map(board => {
      return assignIn({}, board, {
        children: sortBy(board.children, 'position'),
        is_exanded: true,
      });
    });
  },

  cards(state, { boardId, cards }) {
    state.cards[boardId] = cards;
  },

  appId(state, value) {
    state.appId = value;
  },

  boardId(state, value) {
    state.boardId = value;
  },
};

const getters = {
  app(state) {
    return state.apps.find(app => app.id === state.appId);
  },

  boards(state) {
    return state.boards[state.appId] || [];
  },

  board(state, getters) {
    const boards = getters.boards;
    return boards.length
      ? boards.find(board => board.id === state.boardId)
      : null;
  },

  cards(state, getters) {
    const board = getters.board;
    return board ? state.cards[state.boardId] : [];
  },

  getApp(state) {
    return function(id) {
      return state.apps.find(app => app.id === id);
    };
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
